module.exports = __webpack_public_path__ + "static/media/passport.e8df476c.svg";